import { Box, Grid2 } from '@mui/material';
import CardComponent from '../../../components/CardComponent/CardComponent';
import TextFieldComponent from '../../../components/TextFieldComponent';
import ButtonComponent from '../../../components/ButtonComponent';
import { Phone } from '@mui/icons-material';
import DialPadComponent from '../../../components/DialPadComponent';
import React, { useContext, useState } from 'react';
import { useCallSipClientAsync } from '../../../services/SipClientService/hooks/useMutation';
import { AppContext } from '../../../context/AppContextProvider';
import { SipClientStatus } from '../../../services/SipClientService/enums';
import CallRender from './CallRender';
import DeviceLinkWithSipClient from '../DeviceLink/DeviceLinkWithSipClient';
import SipClientFillingReasonModal from '../Reason/SipClientFillingReasonModal';
import SipVideoHistoryManagement from '../History/SipVideoHistoryManagement';

const SipClientManagement = () => {
  const {
    sipClientRegister,
    sipClientStatusDetails,
    showSnackbar,
    isOpenFillingReasonModal,
    setIsOpenFillingReasonModal,
    lastSipClientHistory,
  } = useContext(AppContext);
  const [dialedNumber, setDialedNumber] = useState('');

  const {
    mutateAsync: mutateCallSipClientAsync,
    isLoading: isLoadingCallSipClientAsync,
  } = useCallSipClientAsync();

  const handleKeyPress = (key: string) => {
    if (key === 'C') {
      setDialedNumber('');
    } else if (key === 'R') {
      setDialedNumber((prev) => prev.slice(0, -1));
    } else {
      setDialedNumber((prev) => prev + key);
    }
  };

  const onCallAsync = async (numberPhone?: string) => {
    const destination = numberPhone ?? dialedNumber;

    if (!destination || destination.length == 0) {
      showSnackbar('Digite o número para fazer a ligação!', 'error');
      return;
    }

    const isInvalidSip =
      sipClientRegister &&
      (sipClientRegister.username == destination ||
        sipClientRegister?.displayName == destination);

    if (isInvalidSip) {
      showSnackbar('Você não pode ligar para você mesmo!', 'error');
      return;
    }
    if (sipClientRegister && sipClientRegister.id)
      await mutateCallSipClientAsync({
        id: sipClientRegister.id,
        phoneNumber: destination,
      });
    else {
      showSnackbar('Se registre para poder fazer ligações!', 'error');
    }
  };

  return (
    <Grid2 container columnSpacing={2} rowSpacing={2}>
      <Grid2 size={{ xs: 12, md: 4 }}>
        <CardComponent>
          {sipClientStatusDetails.status == SipClientStatus.NO_ACTIVITY ? (
            <>
              <Box
                justifyContent={'center'}
                display="flex"
                gap={2}
                width="100%"
                alignItems="center"
                mb={2}
              >
                <TextFieldComponent
                  label={'Disque o número'}
                  value={dialedNumber}
                  onChangeText={(e) => setDialedNumber(e)}
                  rightComponent={
                    <ButtonComponent
                      sx={{
                        height: '100%',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                      }}
                      loading={isLoadingCallSipClientAsync}
                      onClick={() => onCallAsync()}
                      color={'warning'}
                    >
                      <Phone />
                    </ButtonComponent>
                  }
                />
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <DialPadComponent onPress={handleKeyPress} />
              </Box>
            </>
          ) : (
            <Box display={'flex'} justifyContent={'center'}>
              <CallRender />
            </Box>
          )}

          {lastSipClientHistory && (
            <SipClientFillingReasonModal
              isOpen={isOpenFillingReasonModal}
              lastSipClientHistoryId={lastSipClientHistory.id}
              onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                  setIsOpenFillingReasonModal(false);
                }
              }}
            />
          )}
        </CardComponent>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 8 }}>
        <Box sx={{ height: '100%' }}>
          <DeviceLinkWithSipClient onCallAsync={onCallAsync} />
        </Box>
      </Grid2>
      <Grid2 size={12}>
        <SipVideoHistoryManagement />
      </Grid2>
    </Grid2>
  );
};

export default SipClientManagement;
